import { useDispatch, useSelector } from 'react-redux'
import { setPatientInfoInEvaluations, setInformInfoInEvaluations } from '../redux/evaluations'
import { useSearchPatient } from './NewCase/useSearchPatient'
import useImagesSelector from './useImagesSelector'
import { useEffect } from 'react'
import { useGetInformFromStudy } from './Inform/useGetInformFromStudy'
import { getUserData } from './Login/UserData/getUserData'
import { updateDataUser } from '../redux/user'

export const useCompleteEvaluationData = () => {
  const dispatch = useDispatch()
  const { user } = useSelector(state => state)
  const { patientData, search } = useSearchPatient()
  const { getInformFromStudy } = useGetInformFromStudy()
  const { handleRestoreImages } = useImagesSelector('right')

  const getFirstInformId = (evaluation) => {
    if (!evaluation || !evaluation.informes) return null

    if (Array.isArray(evaluation.informes)) {
      const firstInform = evaluation.informes[0]
      if (!firstInform) return null
      return firstInform.id || firstInform.idInforme || null
    }

    if (typeof evaluation.informes === 'object') {
      return evaluation.informes.id || evaluation.informes.idInforme || null
    }

    return null
  }

  const getValidInformProjection = (evaluation) => {
    if (!evaluation || !evaluation.informes) return null
    const informes = Array.isArray(evaluation.informes) ? evaluation.informes : []
    const first = informes[0]
    if (!first || typeof first !== 'object') return null
    return first
  }

  const completePatientReadonlyData = async (evaluation) => {
    let patientInfo = user.data || null
    if (!patientInfo) {
      const fetched = await getUserData('patient', user.token)
      if (fetched) {
        dispatch(updateDataUser(fetched))
        patientInfo = fetched
      }
    }
    if (patientInfo) {
      dispatch(setPatientInfoInEvaluations(patientInfo))
    }

    const informProjection = getValidInformProjection(evaluation)
    dispatch(setInformInfoInEvaluations(informProjection || null))

    handleRestoreImages(evaluation)
  }

  const completeEvaluationData = async (evaluation, action) => {
    if (!evaluation) {
      return
    }

    if (action === 'patient-readonly') {
      await completePatientReadonlyData(evaluation)
      return
    }

    if (action !== 'last') {
      await search(evaluation.paciente_id)
      if (action !== 'new') {
        const informId = getFirstInformId(evaluation)
        if (informId) {
          await getInformFromStudy(informId)
        }
      }
    }

    handleRestoreImages(evaluation)
  }

  useEffect(() => {
    if (patientData) {
      dispatch(setPatientInfoInEvaluations(patientData))
    }
  }, [patientData])

  return { completeEvaluationData }
}
